import { DateForm as BaseDateForm } from "../../utils/medicalDocument/form";
import moment from "moment";

const DateForm = (props) => {
  const minDate = moment().subtract(6, "month");
  const maxDate = moment().add(2, "years");

  return <BaseDateForm {...props} minDate={minDate} maxDate={maxDate} />;
};

export default DateForm;
